<template>
  <div class="notePopUp">
    <div class="notePopUp-contents">
      <button id="close-popup" @click="notePopUpClose()">
        X
      </button>
      <h3>What did you find?</h3>
      <div class="divTable">
        <div class="divTableBody">
          <div class="divTableRow">
            <div class="divTableCell">
              <el-button icon="el-icon-camera" circle @click="noteCam()" />
            </div>
            <!--<div class="divTableCell-empty">
&nbsp;
            </div>-->
            <div class="divTableCell">
              <button @click="noteTxt()">
                Txt
              </button>
            </div>
          </div>
          <div class="divTableRow">
            <!--<div class="divTableCell-empty">
&nbsp;
            </div>
            <div class="divTableCell">
              <button id="close-popup" @click="notePopUpClose()">
                X
              </button>
            </div>
            <div class="divTableCell-empty">
&nbsp;
            </div>-->
          </div>
          <div class="divTableRow">
            <div class="divTableCell">
              <button @click="noteMic()">
                Mic
              </button>
            </div>
            <!--<div class="divTableCell-empty">
&nbsp;
            </div>-->
            <div class="divTableCell">
              <button @click="noteDraw()">
                Draw
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase/firestore';
import { mapActions } from 'vuex';
import router from '@/router.js';

export default {
  name: 'InsightNote',
  components: {
  },
  data() {
    return {
      selfiles: null,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions(['fetchNoteShow', 'fetchCamShow', 'fetchTxtShow', 'fetchMicShow', 'fetchDrawShow',]),
    notePopUpClose() {
      this.fetchNoteShow();
    },
    noteCam() {
      this.fetchNoteShow();
      this.fetchCamShow();
      router.push({ name: 'note', params: { userId: firebase.auth().currentUser.uid } });
    },
    noteTxt() {
      this.fetchNoteShow();
      this.fetchTxtShow();
      router.push({ name: 'note', params: { userId: firebase.auth().currentUser.uid } });
    },
    noteMic() {
      this.fetchNoteShow();
      this.fetchMicShow();
      router.push({ name: 'note', params: { userId: firebase.auth().currentUser.uid } });
    },
    noteDraw() {
      this.fetchNoteShow();
      this.fetchDrawShow();
      router.push({ name: 'note', params: { userId: firebase.auth().currentUser.uid } });
    },
    storeImage(event){
      console.log("set image on input-field")
      this.selfiles = event.target.files[0];
    },
  },
};
</script>

<style>
@media screen and (max-width:768px){
  /*画面サイズが480pxからはここを読み込む*/
  .notePopUp-contents{
  width: 300px;
  padding-top: 30px;
  padding-bottom: 50px;
  border-radius: 10px;
  }
  .divTableCell {
  width: 80px;
  height: 80px;
  }
  #close-popup{
  width: 35px;
  height: 35px;
  border-radius: 30px;
  }
}

@media screen and (min-width:768px) and ( max-width:1024px) {
  /*画面サイズが768pxから1024pxまではここを読み込む*/
  .notePopUp-contents{
  width: 400px;
  padding-top: 40px;
  padding-bottom: 70px;
  border-radius: 10px;
  }
  .divTableCell {
  width: 100px;
  height: 100px;
  }
  #close-popup{
  width: 50px;
  height: 50px;
  border-radius: 30px;
  }
}

@media screen and (min-width:1024px) {
  /*画面サイズが1024pxからはここを読み込む*/
  .notePopUp-contents{
  width: 400px;
  padding-top: 40px;
  padding-bottom: 70px;
  border-radius: 10px;
  }
  .divTableCell {
  width: 100px;
  height: 100px;
  }
  #close-popup{
  width: 50px;
  height: 50px;
  border-radius: 30px;
  }
}
.notePopUp{
  position:fixed;
  padding:0;
  margin:0;

  top:0;
  left:0;

  width: 100%;
  height: 100%;
  text-align: center;
}
.notePopUp-contents{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  background-color: rgb(252, 252, 252);
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
}
.divTable{
  margin: auto;
	display: table;
}
.divTableRow {
	display: table-row;
}
.divTableCell {
  border: solid black;
	display: table-cell;
  vertical-align: middle;
}
.divTableCell-empty {
  border: solid black;
  width: 1px;
	display: table-cell;
  vertical-align: middle;
}
.divTableBody {
	display: table-row-group;
}
#close-popup{
  position: absolute;
  top: 5%;
  left: 83%; 
}
</style>
